/**
 * The origin serving the microfrontend, which is our own Express runtime and not
 * the Witboost page hosting us. Everything we serve ourselves — the stylesheet,
 * the runtime configuration, the OAuth callback page — hangs off this.
 *
 * `document.currentScript` is only set while the bundle is executing, so this is
 * computed once at module load. Reading it on demand returns null and silently
 * yields the host's origin instead. The bundle is emitted as an IIFE, so a
 * classic script is executing while this module evaluates.
 */
export const baseUrl: string = (() => {
  try {
    if (typeof document !== 'undefined' && document.currentScript) {
      return `${new URL((document.currentScript as HTMLScriptElement).src).origin}/`;
    }
  } catch { /* fall through */ }

  return `${window.location.origin}/`;
})();
